export const formatPrice = (amount = 0, removeDecimals = false) => {
  const currencyFormatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    maximumFractionDigits: removeDecimals ? 0 : 2,
  });

  return currencyFormatter.format(parseFloat(amount));
};

export const discountPrice = (price, discount) => {
  return price * ((100 - discount) / 100);
};

export const getCheapestProductPrice = (products, removeDecimals) => {
  const cheapestProduct = products.sort(
    (a, b) =>
      a.priceRangeV2.minVariantPrice.amount -
      b.priceRangeV2.minVariantPrice.amount,
  )[0];

  if (cheapestProduct) {
    return formatPrice(
      cheapestProduct.priceRangeV2.minVariantPrice.amount *
        (cheapestProduct.m2Pricing ? 100 : 1),
      removeDecimals,
    );
  }
};
